var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIran(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 480,
    id: "iran",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-85.311 0h682.67v512h-682.67z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(79.98) scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-191.96 0h896v512h-896z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da0000",
    d: "M-191.96 343.84h896V512h-896z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-21.628 350.958h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.379 367.736v3.377H33.794v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.614 350.958h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.763 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.763 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.763 359.849h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27H7.27zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.639 367.736v3.377h-15.14v-3.377zm1.007-8.754v3.377H1.048v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-102.228 350.958h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.221 367.736v3.377h-18.585v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30.986 350.958h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.837 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.837 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.837 359.849h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27h-3.377zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-70.961 367.736v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.297 350.958h49.07v3.377h-49.07zm7.316 16.884h3.376v3.28h-3.376zm41.881-.106v3.377h-9.807v-3.377zm5.275-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.303 367.736v3.377H113.72v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.539 350.958h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.299 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.687 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.687 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.687 359.849h3.377v11.27h-3.377zm-39.299 0h3.377v11.27h-3.377zm28.806 0h3.377v11.27h-3.377zm-14.272 0H76.3v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.563 367.736v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.682 350.958h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.689 367.736v3.377h-18.585v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.924 350.958h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.073 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.073 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.073 359.849h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27h-3.377zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.949 367.736v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.742 350.958h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.749 367.736v3.377h-18.585v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.984 350.958h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.133 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.133 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.133 359.849h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27h-3.377zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.009 367.736v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.482 350.958h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.489 367.736v3.377h-18.585v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.724 350.958h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.873 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.873 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.873 359.849h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27h-3.377zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.749 367.736v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#239f40",
    d: "M-191.96 0h896v168.16h-896z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.692 350.958h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.699 367.736v3.377h-18.585v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.934 350.958h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.083 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.083 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.083 359.849h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27h-3.377zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.959 367.736v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.422 350.958h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.429 367.736v3.377h-18.585v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.664 350.958h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.813 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.813 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.813 359.849h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27h-3.377zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.689 367.736v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.162 350.958h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.169 367.736v3.377h-18.585v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.404 350.958h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.553 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.553 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.553 359.849h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27h-3.377zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.429 367.736v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543.372 350.958h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.379 367.736v3.377h-18.585v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.614 350.958h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.763 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.763 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.763 359.849h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27h-3.377zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.639 367.736v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-183.788 350.958h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109.781 367.736v3.377h-18.585v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-112.546 350.958h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.397 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.397 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.397 359.849h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27h-3.377zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-152.521 367.736v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-21.628 143.442h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.379 160.22v3.377H33.794v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.614 143.442h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.763 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.763 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.763 152.333h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27H7.27zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.639 160.22v3.377h-15.14v-3.377zm1.007-8.754v3.377H1.048v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-102.228 143.442h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.221 160.22v3.377h-18.585v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30.986 143.442h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.837 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.837 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.837 152.333h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27h-3.377zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-70.961 160.22v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.297 143.442h49.07v3.377h-49.07zm7.316 16.884h3.376v3.28h-3.376zm41.881-.106v3.377h-9.807v-3.377zm5.275-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.303 160.22v3.377H113.72v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.539 143.442h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.299 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.687 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.687 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.687 152.333h3.377v11.27h-3.377zm-39.299 0h3.377v11.27h-3.377zm28.806 0h3.377v11.27h-3.377zm-14.272 0H76.3v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.563 160.22v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.682 143.442h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.689 160.22v3.377h-18.585v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.924 143.442h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.073 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.073 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.073 152.333h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27h-3.377zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.949 160.22v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.742 143.442h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.749 160.22v3.377h-18.585v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.984 143.442h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.133 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.133 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.133 152.333h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27h-3.377zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.009 160.22v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.482 143.442h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.489 160.22v3.377h-18.585v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.724 143.442h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.873 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.873 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.873 152.333h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27h-3.377zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.749 160.22v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.692 143.442h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.699 160.22v3.377h-18.585v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.934 143.442h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.083 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.083 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.083 152.333h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27h-3.377zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.959 160.22v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.422 143.442h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.429 160.22v3.377h-18.585v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.664 143.442h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.813 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.813 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.813 152.333h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27h-3.377zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.689 160.22v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.162 143.442h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.169 160.22v3.377h-18.585v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.404 143.442h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.553 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.553 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.553 152.333h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27h-3.377zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.429 160.22v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543.372 143.442h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.379 160.22v3.377h-18.585v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.614 143.442h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.763 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.763 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.763 152.333h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27h-3.377zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.639 160.22v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-183.788 143.442h49.07v3.377h-49.07zm7.316 16.884h3.377v3.28h-3.377zm41.882-.106v3.377h-9.807v-3.377zm5.274-16.778h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109.781 160.22v3.377h-18.585v-3.377zm-34.616-7.887h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-112.546 143.442h3.377v20.16h-3.377zm-8.442 0h3.377v20.16h-3.377zm-44.799 8.024v3.377h-17.91v-3.377zm39.3 0v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.397 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.397 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.397 152.333h3.377v11.27h-3.377zm-39.3 0h3.377v11.27h-3.377zm28.807 0h3.376v11.27h-3.377zm-14.272 0h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-152.521 160.22v3.377h-15.14v-3.377zm1.007-8.754v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#d90000",
    d: "M-68.83 339.507h6.048v10.505h-6.048zm160.532 0h6.048v10.505h-6.048zm-283.705 0h6.048v10.505h-6.048zm81.475 0h6.048v10.505h-6.048zm80.895 0h6.048v10.505h-6.048zm40.024 0h6.049v10.505h-6.05zm40.861 0H57.3v10.505h-6.048zm80.475 0h6.048v10.505h-6.048zm203.056 0h6.048v10.505h-6.048zm-162.197 0h6.048v10.505h-6.048zm40.035 0h6.048v10.505h-6.048zm40.438 0h6.048v10.505h-6.048zm40.448 0h6.048v10.505h-6.048zm323.143 0h6.047v10.505h-6.048zm-242.67 0h6.048v10.505h-6.048zm40.86 0h6.049v10.505h-6.049zm41.284 0h6.049v10.505h-6.049zm38.776 0h6.049v10.505H494.9zm41.274 0h6.048v10.505h-6.048zm40.448 0h6.048v10.505h-6.048zm119.674 0h6.048v10.505h-6.048zm-38.778 0h6.048v10.505h-6.048zm-808.908 0h6.048v10.505h-6.048z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#239e3f",
    d: "M-68.83 162.607h6.048v10.505h-6.048zm160.532 0h6.048v10.505h-6.048zm-283.705 0h6.048v10.505h-6.048zm81.475 0h6.048v10.505h-6.048zm80.895 0h6.048v10.505h-6.048zm40.024 0h6.049v10.505h-6.05zm40.861 0H57.3v10.505h-6.048zm80.475 0h6.048v10.505h-6.048zm203.056 0h6.048v10.505h-6.048zm-162.197 0h6.048v10.505h-6.048zm40.035 0h6.048v10.505h-6.048zm40.438 0h6.048v10.505h-6.048zm40.448 0h6.048v10.505h-6.048zm323.143 0h6.047v10.505h-6.048zm-242.67 0h6.048v10.505h-6.048zm40.86 0h6.049v10.505h-6.049zm41.284 0h6.049v10.505h-6.049zm38.776 0h6.049v10.505H494.9zm41.274 0h6.048v10.505h-6.048zm40.448 0h6.048v10.505h-6.048zm119.674 0h6.048v10.505h-6.048zm-38.778 0h6.048v10.505h-6.048zm-808.908 0h6.048v10.505h-6.048z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#da0000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.8 197.489c8.453 10.36 34.511 67.652-15.73 105.18-23.62 17.777-8.994 18.675-8.296 21.663 37.966-20.167 50.366-47.49 50.078-71.966-.29-24.476-13.266-46.102-26.052-54.873z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.826 194.826c18.75 9.6 59.553 57.879 15.635 112.344 27.288-6.056 61.98-86.417-15.635-112.344zm-57.581 0c-18.749 9.6-59.553 57.879-15.635 112.344-27.288-6.056-61.98-86.417 15.635-112.344z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2 197.489c-8.454 10.36-34.512 67.652 15.73 105.18 23.618 17.777 8.993 18.675 8.294 21.663-37.965-20.167-50.365-47.49-50.077-71.966.289-24.476 13.265-46.102 26.052-54.873z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.198 319.111c-14.86.236-33.593-2.047-47.486-9.267 2.288 4.45 4.189 7.252 6.477 11.701 13.25 1.222 31.535 2.734 41.01-2.434zm-94.973 0c14.86.236 33.593-2.047 47.487-9.267-2.289 4.45-4.19 7.252-6.478 11.701-13.25 1.222-31.535 2.734-41.01-2.434zm27.257-138.714c3.011 8.002 10.91 9.165 19.365 4.454 6.161 3.697 15.69 3.93 18.976-4.067 2.499 19.784-18.305 15.104-19.08 11.231-7.745 7.487-22.165 3.163-19.26-11.618z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.402 331.569 7.813-8.93 1.117-120.178-9.302-8.185-9.3 7.813 1.859 120.92 7.813 8.558z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIran);
export default __webpack_public_path__ + "static/media/iran.d7de48e6889c05d7cef756a6bd11d47d.svg";
export { ForwardRef as ReactComponent };